import { Cabecalho } from './styles'

const cabecalhoHeader = () => (
  <Cabecalho>
    <h1>EBAC Jobs</h1>
  </Cabecalho>
)

export default cabecalhoHeader
